import { CircularProgress, Stack, Typography } from "@mui/material";
import "./common.scss";

interface CustomLoaderInterface {
    message?: string;
}

const CustomLoader = (props: CustomLoaderInterface) => {
    const { message } = props;
    return <Stack direction={"column"} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} className="custom-top-margin">
        <CircularProgress color="secondary" />
        <Typography variant="button" component={"h6"} className=" mt-3 mb-3" sx={{ fontFamily: "Signika", fontWeight: "bold", fontSize: "1rem" }}>
            {message ? message : "PROCESSING"}
        </Typography>
    </Stack>

}

export default CustomLoader;